import React, { useState } from 'react';
import axios from 'axios';

// ANTD
import { Button, Form, Input } from 'antd';

// STYLES
import './styles.scss';

export const OPENSEA_URL_REGEX = /https:\/\/opensea.io\/assets\/ethereum\/0x5d26060847445efb92c6f03d1382bcdd07b67280\/\d+$/g;
export const OPENSEA_REFRESH_ERROR = "There was an error requesting the refresh of OpenSea metadata.";
export const CLAIM_STATUS_ERROR = "There was an error retrieving the claiming status.";

export const VALIDATION_URL_ERROR_MSG = "URL not valid!";
export const VALIDATION_OUT_OF_REACH_ERROR_MSG = "Token ID out of reach!";

function ClaimStatus() {

    const [loadingState, setLoadingState] = useState<boolean>(false);
    const [errorState, setErrorState] = useState<boolean>(false);
    const [formValidState, setFormValidState] = useState<boolean>(false);
    const [nftItemState, setNftItemState] = useState<any>(null);
    const [claimStatusState, setClaimStatusState] = useState<boolean | undefined>(undefined);
    const [errorMsgState, setErrorMsgState] = useState<string>();
    const [validationErrorMsgState, setValidationErrorMsgState] = useState<string>();

    const urlRegex = new RegExp(OPENSEA_URL_REGEX);

    const [form] = Form.useForm();

    const checkClaimStatus = async (): Promise<void> => {

        setLoadingState(true);

        try {

            setNftItemState(null);

            const openSeaUrl = form.getFieldValue('opensea-url');
            const tokenId = openSeaUrl.split('/')[6];

            refreshOpenSeaMetadata(tokenId);

            const claimStatusResponse = await axios.get(`${process.env.REACT_APP_API_URL}/nft/metadata/${tokenId}`);
            const nftItemMetadata = claimStatusResponse.data.data;

            setNftItemState(nftItemMetadata);

            if (nftItemMetadata.attributes[1].value === 'NO') {
                setClaimStatusState(false);
            } else if (nftItemMetadata.attributes[1].value === 'YES') {
                setClaimStatusState(true);
            }

            setLoadingState(false);

        } catch (error: any) {

            setErrorMsgState(CLAIM_STATUS_ERROR);

            setErrorState(true);
            setLoadingState(false);
        }

    };

    const tryAgain = (): void => {
        setErrorState(false);
    };

    const refreshOpenSeaMetadata = async (tokenId: number): Promise<void> => {
        try {
            await axios.get(`https://api.opensea.io/api/v1/asset/0x5d26060847445efb92c6f03d1382bcdd07b67280/${tokenId}/?force_update=true`);
        } catch (error: any) {

            setErrorMsgState(OPENSEA_REFRESH_ERROR);

            setErrorState(true);
            setLoadingState(false);

        }
    };

    const checkOpenSeaUrl = (): void => {

        const isUrlValid = urlRegex.test(form.getFieldValue('opensea-url'));

        const openSeaUrl = form.getFieldValue('opensea-url');
        const tokenId = openSeaUrl.split('/')[6];

        if (isUrlValid && tokenId <= 10754) {
            setFormValidState(true);
        } else if (isUrlValid && tokenId > 10754) {
            setValidationErrorMsgState(VALIDATION_OUT_OF_REACH_ERROR_MSG);
            setFormValidState(false);
        } else if (!isUrlValid) {
            setValidationErrorMsgState(VALIDATION_URL_ERROR_MSG);
            setFormValidState(false);
        }
    };

    if (errorState) {
        return (
            <div className="claim-status-container">
                <div className="claim-status-content">
                    <div className="claim-status-header">
                        Check NFT Claim  Status
                    </div>
                    <div className="claim-form-container">
                        <h2>{errorMsgState}</h2>
                        <Button type="primary" size="large" shape="round" onClick={() => tryAgain()} loading={loadingState}>Try Again</Button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="claim-status-container">
            <div className="claim-status-content">
                <div className="claim-form-container">
                    <h1>Check your Realtà Parallela NFT claim status</h1>
                    <p>This is the official source for checking the claim status of your Dolce&Gabbana Realtà Parallela NFT. All information comes directly from UNXD’s internal servers and is updated in real time. Due to OpenSea’s operating policy, there can be latency in showing the updated NFT claim status on their site.</p>
                    <p><strong>Please ensure you check the claim status of any individual NFT on this site before purchasing on OpenSea.</strong> Neither UNXD nor Dolce&Gabbana take any responsibility for any already-claimed NFTs purchased mistakenly from OpenSea.</p>
                    <ul>
                        <li>Go to the individual page of the specific NFT you are looking to purchase on OpenSea</li>
                        <li>Copy the full page URL</li>
                        <li>Paste the URL below and click ‘Check Status’</li>
                    </ul>
                    <Form form={form}>
                        <Form.Item name="opensea-url" rules={[{ required: true, pattern: new RegExp(OPENSEA_URL_REGEX), message: validationErrorMsgState }]}>
                            <Input className="url-input" onChange={() => checkOpenSeaUrl()} placeholder="https://opensea.io/assets/ethereum/0x5d26060847445efb92c6f03d1382bcdd07b67280/:tokenId" />
                        </Form.Item>
                    </Form>
                    {claimStatusState === true ? <span className="claimed-status">Your token has been claimed!</span> : null}
                    {claimStatusState === false ? <span className="claimed-status">Your token has not been claimed yet!</span> : null}
                    <div className="check-button-container">
                        <Button type="primary" size="large" shape="round" disabled={!formValidState || loadingState} onClick={() => checkClaimStatus()} loading={loadingState}>Check status</Button>
                    </div>
                    {nftItemState ? (
                        <div className="nft-item">
                            <img src={nftItemState.image} />
                            <span>{nftItemState.name}</span>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default ClaimStatus;